define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var LPModel = require('web-agent-framework/LPModel');

    window.lpTag = window.lpTag || {};
    /**
     * Model controller that manage the public model and expose the API of it.
     * The public model is a slim proxy model of the private model with different mapping of the information.
     * It aggregate properties only on bind event, and delete the properties after the last unbind.
     * The controller will be the one that create the public model and be the only one that hold the instance of it.
     *
     * @param privateModel
     * @returns publicModelController
     */
    lpTag.lpPublicModelController = function (privateModel) {
        var publicModelController = {applicationType: "lpPublicModelController"};

        var logger = WebAgentLogger.getLogger(publicModelController.applicationType);
        var publicModel;
        var bindKeyArray = [];
        var bindPrivateCallbackList = {}; // list of all callback
        var publicModelMap;  // Object with the public model structure and mapping to the private model
        var privateModelKeyArray = {}; // Array of all the private model keys and mapping to the public model
        var rootKey; // the key of the engagement id in the map
        var privateModelBindKey;  // the key of the private model bind list in the map
        var startModelUpdate = false;
        var modifyObject = {};

        function init() {
            //Create an empty model
            var model = {};
            // In case we need to return the old LPModel
            //return new window.lpTag.LPModel(model, lpTag.WebAgent.WebAgentLogger.getLogger("LPModel"));
            publicModel = new LPModel(model, WebAgentLogger.getLogger("LPPublicModel"));

            // Read config file
            publicModelMap = lpUtils.cloneObject(require('web-agent-config/publicModel.json'));
            privateModelBindKey = publicModelMap.privateModelBindKey;
            rootKey = publicModelMap.rootKey;
            // Map the config file to an index array of privateKey = publicKey
            _indexObjectToArray(publicModelMap.publicStructure, null, privateModelKeyArray);

        }

        /**
         * The public function of get call the privet one.
         * @param key
         * @returns {*}
         */
        publicModelController.get = function (key) {
            return _get(key);
        };

        /**
         * Bind to changes on a model property
         * @param key - The property key to bind to. (String). TODO: add multi bind
         * @param callback - The callback function to run when trigger.
         * @param context - The context to run the callback function.
         * @param trigger - (optional) Get an event with the property on bind (defaults: true).
         * @param deepBind - (optional) Allows get trigger for child's changes (defaults: false).
         */
        publicModelController.bind = function (key, callback, context, trigger, deepBind) {
            if (typeof(key) !== "string") {
                return;
            }
            // trigger defaults is true
            trigger = trigger !== false ? true : false;

            // Add bind to the bindArray.
            var keyArray = bindKeyArray[key] || (bindKeyArray[key] = []);
            keyArray.push({
                key: key,
                callback: callback,
                context: context,
                deepBind: deepBind
            });
            // check if this is the first bind to this key
            if (keyArray.length == 1) {
                // check their is a bind on parent
                var splitKey = key.split(".");
                var tempKey = "";
                // Loop the key path and check that no bind on parent. if bind then exit the function
                for (var j = 0; j < splitKey.length - 1; j++) {

                    // Adding . before the next splitted key if it is not first splitted key
                    tempKey += (tempKey === "") ? splitKey[j] : "." + splitKey[j];
                    // if bind then bind to the public model and exit the function
                    if (bindKeyArray[tempKey] && bindKeyArray[tempKey].length > 0) {
                        _bindToPublicModel(key, callback, context, trigger, deepBind);
                        return;
                    }
                }
                // add this key to the model
                addPropertyToModel(key);
                // Bind to the property in the public model
                setTimeout(function(){_bindToPublicModel(key, callback, context, trigger, deepBind);}, 0);

            }
        };

        /**
         * We bind to the public model with no trigger.
         * If trigger needed we use the get from the privet model and trigger the results
         * @param key - The property key to bind to. (String).
         * @param callback - The callback function to run when trigger.
         * @param context - The context to run the callback function.
         * @param trigger - (optional) Get an event with the property on bind (defaults: true).
         * @param deepBind - (optional) Allows get trigger for child's changes (defaults: false).
         * @private
         */
        function _bindToPublicModel(key, callback, context, trigger, deepBind) {
            if (trigger) {
                var newValue = _get(key);
                if (newValue !== null && !(newValue && typeof newValue === 'object' && Object.keys(newValue).length === 0)) { // Call the trigger only if get returns data
                    callback.call(context || this, {
                        key: key,
                        newValue: newValue,
                        oldValue: null
                    });
                }
            }
            publicModel.bind(key, callback, context, false, deepBind);
        }
        /**
         * Unbind on model property
         * @param key - The property key to bind to. (String or array of strings).
         * @param callback - The callback function to run when trigger.
         * @param context - The context to run the callback function.
         */
        publicModelController.unbind = function (key, callback, context) {
            if (typeof(key) !== "string") {
                return;
            }
            //Unbind to the public model
            publicModel.unbind(key, callback, context);
            // Remove from the bindKeyArray
            var keyArray = bindKeyArray[key] || (bindKeyArray[key] = []);
            var data;
            for (var i = 0; i < keyArray.length; i++) {
                data = keyArray[i];
                if (key === data.key &&
                    callback === data.callback &&
                    context === data.context) {
                    keyArray.splice(i, 1);
                }
            }
            // Check if this is the last bind and no parent with bind, and remove the property from the model
            if (keyArray.length === 0) {
                removePropertyFromModel(key);
            }
        };

        /**
         * The get need to use the mapping in order to run the get on the private model and not on the public model.
         * @param key
         * @returns {*}
         */
        function _get(key) {
            if (typeof(key) !== "string") {
                return;
            }
            var res = {};
            // Get the root ID
            var rootID = key.split(".")[0];
            var privatePath = _getPrivatePath(key, rootID);
            // if path is not fix then get the parent path and look for the relative public path in the private results
            if (privatePath && privatePath.parent) {
                var privateResults = _buildGetResults(privatePath.results, rootID); // get the privateResults of the parent
                var tempObj = {};
                _setDeepValue(tempObj, privatePath.parent.replace(rootKey, rootID), privateResults); // create an object with the key of the public and the results of the private
                var newRes = _getDeepValue(tempObj, key); // get the results from the combined tree
                if (typeof(newRes.parent) === "undefined") { // check that the leaf exist
                    res = newRes.results;
                }
            } else {
                // Build the get results
                res = _buildGetResults(privatePath.results, rootID);
            }
            return res;
        }

        /**
         * Bind to the private model using the public model key
         * @param key
         */
        function addPropertyToModel(key) {
            if (typeof(key) !== "string") {
                return;
            }
            // Use the map to get the key/s of the private model
            var rootID = key.split(".")[0];
            var privatePath = lpUtils.cloneObject(_getPrivatePath(key, rootID, true).results);
            if (typeof(privatePath) === "string") {
                privatePath = privatePath.replace(rootKey, rootID);
            } else if (privatePath) {
                for (var i = 0; i < privatePath.length; i++) {
                    privatePath[i] = privatePath[i].replace(rootKey, rootID);
                }
            }
            // Deep bind the private model property to the public model
            var callBackFunction = createCallBack(rootID);
            privateModel.bind(privatePath, callBackFunction, this, false, true);
            bindPrivateCallbackList[key] = callBackFunction;
        }

        /**
         * Create a callback function for the bind
         * @param rootID
         * @returns {Function}
         */
        function createCallBack(rootID) {
            return function(data){agentCallback(data,rootID);};
        }
        /**
         * Unbind from the private model and remove the property from the public model
         * @param key
         */
        function removePropertyFromModel(key) {
            if (typeof(privatePath) !== "string") {
                return;
            }
            // Use the map to get the key/s of the private model
            var rootID = key.split(".")[0];
            var privatePath = _getPrivatePath(key, rootID, true).results;
            if (typeof(privatePath) === "string") {
                privatePath = privatePath.replace(rootKey, rootID);
            } else if (privatePath) {
                for (var i = 0; i < privatePath.length; i++) {
                    privatePath[i] = privatePath[i].replace(rootKey, rootID);
                }
            }
            if (privatePath) { // only if privatePath found
                // Unbind the private model property to the public model
                privateModel.unbind(privatePath, bindPrivateCallbackList[key], this);
                bindPrivateCallbackList[key] = null;

                // Remove the property from the public model
                // check that no bind on parent
                var splitKey = key.split(".");
                var tempKey = "";
                // Loop the key path and check that no bind on parent. if bind then exit the function
                for (var j = 0; j < splitKey.length - 1; j++) {
                    tempKey += (tempKey === "") ? splitKey[j] : "." + splitKey[j];
                    // if bind then exit the function
                    if (bindKeyArray[tempKey] && bindKeyArray[tempKey].length > 0) {
                        return;
                    }
                }
                // Remove the key from the model
                publicModel.removeKey(key);
            }
        }

        /**
         * Callback function for the private model bind
         * @param data
         */
        function agentCallback(data, rootID) {
            if (data && !_.isEqual(data.newValue, data.oldValue)) { // if old value equal to new value then there is no change to update
                if (!startModelUpdate) {
                    setTimeout(_startModelUpdate, 0);
                    startModelUpdate = true;
                }
                _updateModifyObject(data.key, data.newValue, data.oldValue, rootID);
            }
        }

        /**
         * This function call after the end of all triggered agentCallback and modify the public model with all the changes
         * @private
         */
        function _startModelUpdate() {
            startModelUpdate = false;
            var key = Object.keys(modifyObject)[0]; // get the ID from the first key
            if (typeof(key) !== "undefined") {
                publicModel.set(key, modifyObject[key]);
            }

            modifyObject = {};
        }

        // TODO: Handle oldValue and remove value
        /**
         * Go over the newValue and update the modifyObject in order to modify the model
         * @param key (String)
         * @param newValue (*)
         * @param rootID The rootID parameter (String)
         * @private
         */
        function _updateModifyObject(key, newValue, oldValue, rootID) {
            var mapKey = key.replace(rootID, rootKey);
            if (typeof newValue === 'object' && newValue.constructor !== Array) { // if parent, build an object and return it. if array don't go in
                for (var keys in newValue) {
                    if (newValue.hasOwnProperty(keys) && keys !== privateModelBindKey) { // remove the model bind params
                        var oldValueForCallback = oldValue !== null && typeof oldValue !== "undefined" ? oldValue[keys] : null;
                        _updateModifyObject(key + "." + keys, newValue[keys], oldValueForCallback, rootID);
                    }
                }
            } else if (mapKey in privateModelKeyArray) { // if leaf, return the private model get of the key and the key is in the map then modify all the value
                if (!_.isEqual(newValue, oldValue)) {
                    var publicModelKeys = privateModelKeyArray[mapKey];
                    for (var publicModelKey in publicModelKeys) {
                        var publicKey = publicModelKeys[publicModelKey].replace(rootKey, rootID);
                        var publicValue = publicModel.get(publicKey);
                        if (!_.isEqual(newValue, publicValue)) {
                            _setDeepValue(modifyObject, publicKey, newValue);
                        }
                    }
                }
            }
        }

        /**
         * Convert deep level object to array when value in object became key in array and key in object became the value of the array
         * @param mainObject - the object that need to be convert
         * @param parentName - The main key name of object
         * @param outputArray - The output array
         * @private
         */
        function _indexObjectToArray(mainObject, parentName, outputArray) {
            if (typeof(mainObject) === "undefined") {
                return;
            }
            for (var key in mainObject) {
                if (mainObject.hasOwnProperty(key) && privateModelBindKey !== key) {
                    var newValue = parentName ? parentName + "." + key : key;
                    if (typeof mainObject[key] === 'object') {
                        _indexObjectToArray(mainObject[key], newValue, outputArray);
                    } else {
                        (outputArray["" + mainObject[key]] = outputArray["" + mainObject[key]] || []).push(newValue);
                    }
                }
            }
        }

        /**
         * Use the rootID to create the private model path
         * @param key (String)
         * @param rootID The rootID parameter (String)
         * @param getBindInfo - true is this is a request from bind of unbind, then return the parent bind array if necessary
         * @returns {*}
         * @private
         */
        function _getPrivatePath(key, rootID, getBindInfo) {
            var publicKey = key.replace(rootID, rootKey);
            // get the agent path
            return _getDeepValue(publicModelMap.publicStructure, publicKey, getBindInfo);
        }

        /**
         * Returns the value of key in object using a string path
         * @param modelMap - The object (Object)
         * @param path - A path of keys in the object (String) (exs. "key1.key2.key3")
         * @param isGetBindPath - if true return the privateModelBindKey array of the path (boolean)
         * @returns {*}
         * @private
         */
        function _getDeepValue(modelMap, path, isGetBindPath) {
            var bindResult;
            path = path.split('.'); // Build an array out of the path string
            for (var i = 0, len = path.length; i < len; i++) { // Loop the path's key array
                if (typeof(modelMap[path[i]]) !== "undefined") { // Check that key is in the map
                    if (isGetBindPath) { // If asked for the bind path
                        if (modelMap[path[i]][privateModelBindKey]) {
                            bindResult = modelMap[path[i]][privateModelBindKey];
                        } else if (typeof(modelMap[path[i]]) === "string") {
                            bindResult = modelMap[path[i]];
                        }
                    }
                    modelMap = modelMap[path[i]];
                } else { // key is not in the map
                    if (!isGetBindPath) { // if this is got the get command
                        if (typeof(modelMap) === "string") { // for string in the parent, return the parent
                            return {results:modelMap, parent:path.slice(0,i).join(".")};
                        } else { // if no string return null
                            return {results: null};
                        }
                    }
                }
            }
            var results;
            if (isGetBindPath && typeof(modelMap) !== "string") {
                results = bindResult;
            } else {
                results = modelMap;
            }
            return {results: results};
        }

        /**
         * Recursively function that set value in side an object and build the object path if necessary
         * @param obj - The object (Object)
         * @param path - Keys path of the value (String) (exs. "key1.key2.key3")
         * @param value - Value (*)
         * @private
         */
        function _setDeepValue(obj, path, value) {
            var keys = path.split(".");
            var nextKey = keys.shift();
            if (keys.length === 0) {
                obj[nextKey] = value;
            } else {
                if (typeof(obj[nextKey]) !== "object") {
                    obj[nextKey] = {};
                }
                _setDeepValue(obj[nextKey], keys.join("."), value);
            }
        }
        /**
         * Recursively function that build an object with the results of a get from the private model.
         * If ony leaf is request then only the leaf results will returned, but if a full object is request then an object will be returned
         * @param privatePath - The requested public leaf or branch to get. (string/object)
         * @param rootID - The rootID parameter (String)
         * @returns {*}
         * @private
         */
        function _buildGetResults(privatePath, rootID) {
            if (typeof privatePath === 'object') { // if parent, build an object and return it
                var newObj = {}; // Build the object that will be return
                for (var key in privatePath) { // Loop the keys in the object
                    if (privatePath.hasOwnProperty(key)) {
                        if (key !== privateModelBindKey) { // remove the model bind param
                            newObj[key] = _buildGetResults(privatePath[key], rootID); // insert the results of the recursive into the new object
                        }
                    }
                }
                return newObj;
            } else { // if leaf return the private model get of the key
                return privateModel.get(privatePath.replace(rootKey, rootID));
            }
        }
        init();
        return publicModelController;
    };

    return lpTag.lpPublicModelController;

});
